import { Spinner } from './Spinner';

/** Pantalla de arranque, mientras se recupera la sesión guardada. */
export function Splash() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-surface text-brand">
      <Spinner size="lg" label="Cargando la aplicación" />
    </div>
  );
}
